export default __webpack_public_path__ + "static/favicon-675ead3c93fe41c7295f6957ef9c2bc2.ico";